module.exports = __webpack_public_path__ + "static/media/5.bb39b427.jpeg";